import {Mutations} from "vuex-smart-module";
import WarehouseAdminState, {WarehouseAdminStatus} from "@/store/modules/warehouse-admin/warehouse-admin-state";
import WarehouseAdminProductListData from "@/http/data/warehouse-admin-product-list-data";
import WarehouseAdminProductData from "@/http/data/warehouse-admin-product-data";
import WarehouseAdminOptionsData from "@/http/data/warehouse-admin-options-data";
import WarehouseAdminOrderData from "@/http/data/warehouse-admin-order-data";
import WarehouseAdminStockProductData from "@/http/data/warehouse-admin-stock-product-data";
import WarehouseAdminRestockData from "@/http/data/warehouse-admin-restock-data";
import WarehouseAdminRetourData from "@/http/data/warehouse-admin-retour-data";
import WarehouseAdminSupplierData from "@/http/data/warehouse-admin-supplier-data";
import WarehouseAdminSupplierInvoiceData from "@/http/data/warehouse-admin-supplier-invoice-data";
import WarehouseAdminOrderBuildingReportData from "@/http/data/warehouse-admin-order-building-report-data";
import WarehouseAdminDeliveredTotalsByBuildingReportData from "@/http/data/warehouse-admin-delivered-totals-by-building-report-data";
import WarehouseAdminSimpleProductReportData from "@/http/data/warehouse-admin-simple-product-report-data";
import WarehouseAdminDeliveredTotalsByPeriodReportData from "@/http/data/warehouse-admin-delivered-totals-by-period-report-data";
import WarehouseAdminResupplyTaskData from "@/http/data/warehouse-admin-resupply-task-data";

export default class WarehouseAdminMutations extends Mutations<WarehouseAdminState> {
    setProducts(products: WarehouseAdminProductListData[]): void {
        this.state.products = products;
    }

    setProduct(product: WarehouseAdminProductData|null): void {
        this.state.product = product;
    }

    setOptions(options: WarehouseAdminOptionsData|null): void {
        this.state.options = options;
    }

    setProductsStatus(status: WarehouseAdminStatus): void {
        this.state.productsStatus = status;
    }

    setProductStatus(status: WarehouseAdminStatus): void {
        this.state.productStatus = status;
    }

    setOptionsStatus(status: WarehouseAdminStatus): void {
        this.state.optionsStatus = status;
    }

    setOrder(order: WarehouseAdminOrderData|null): void {
        this.state.order = order;
    }
    setOrders(orders: WarehouseAdminOrderData[]): void {
        this.state.orders = orders;
    }

    setOrderStatus(status: WarehouseAdminStatus): void {
        this.state.orderStatus = status;
    }

    setOrdersStatus(status: WarehouseAdminStatus): void {
        this.state.ordersStatus = status;
    }

    setStock(stock: WarehouseAdminStockProductData[]): void {
        this.state.stock = stock;
    }

    setStockStatus(status: WarehouseAdminStatus): void {
        this.state.stockStatus = status;
    }

    setStockBuilding(building: string|null): void {
        this.state.stockBuilding = building;
    }

    setRestocks(restocks: WarehouseAdminRestockData[]): void {
        this.state.restocks = restocks;
    }

    setRestocksStatus(status: WarehouseAdminStatus): void {
        this.state.restocksStatus = status;
    }

    setRetours(retours: WarehouseAdminRetourData[]): void {
        this.state.retours = retours;
    }

    setRetoursStatus(status: WarehouseAdminStatus): void {
        this.state.retoursStatus = status;
    }

    setRestockHistory(history: WarehouseAdminRestockData[]): void {
        this.state.restockHistory = history;
    }

    setRestockHistoryStatus(status: WarehouseAdminStatus): void {
        this.state.restockHistoryStatus = status;
    }

    setIsSaving(value: boolean): void {
        this.state.isSaving = value;
    }

    setIsInitialized(value = true): void {
        this.state.isInitialized = value;
    }

    setSuppliers(suppliers: WarehouseAdminSupplierData[]): void {
        this.state.suppliers = suppliers;
    }

    setSuppliersStatus(status: WarehouseAdminStatus): void {
        this.state.suppliersStatus = status;
    }

    setSupplierInvoices(invoices: WarehouseAdminSupplierInvoiceData[]): void {
        this.state.supplierInvoices = invoices;
    }

    setSupplierInvoicesStatus(status: WarehouseAdminStatus): void {
        this.state.supplierInvoicesStatus = status;
    }

    setSupplierInvoicesSupplierId(supplierId: number|null): void {
        this.state.supplierInvoicesSupplierId = supplierId;
    }

    setOrderBuildingReport(report: WarehouseAdminOrderBuildingReportData|null): void {
        this.state.orderBuildingReport = report;
    }

    setOrderBuildingReportStatus(status: WarehouseAdminStatus): void {
        this.state.orderBuildingReportStatus = status;
    }

    setDeliveredTotalsByBuildingReport(
        report: WarehouseAdminDeliveredTotalsByBuildingReportData|null
    ): void {
        this.state.deliveredTotalsByBuildingReport = report;
    }

    setDeliveredTotalsByBuildingReportStatus(status: WarehouseAdminStatus): void {
        this.state.deliveredTotalsByBuildingReportStatus = status;
    }

    setSimpleProductReport(report: WarehouseAdminSimpleProductReportData|null): void {
        this.state.simpleProductReport = report;
    }

    setSimpleProductReportStatus(status: WarehouseAdminStatus): void {
        this.state.simpleProductReportStatus = status;
    }

    setDeliveredTotalsByPeriodReport(
        report: WarehouseAdminDeliveredTotalsByPeriodReportData|null
    ): void {
        this.state.deliveredTotalsByPeriodReport = report;
    }

    setDeliveredTotalsByPeriodReportStatus(status: WarehouseAdminStatus): void {
        this.state.deliveredTotalsByPeriodReportStatus = status;
    }

    setResupplyTasks(tasks: WarehouseAdminResupplyTaskData[]): void {
        this.state.resupplyTasks = tasks;
    }

    setResupplyTasksStatus(status: WarehouseAdminStatus): void {
        this.state.resupplyTasksStatus = status;
    }

    clear(): void {
        this.state.products = [];
        this.state.product = null;
        this.state.options = null;
        this.state.productsStatus = WarehouseAdminStatus.Failed;
        this.state.productStatus = WarehouseAdminStatus.Failed;
        this.state.optionsStatus = WarehouseAdminStatus.Failed;
        this.state.order = null;
        this.state.orders = [];
        this.state.orderStatus = WarehouseAdminStatus.Failed;
        this.state.ordersStatus = WarehouseAdminStatus.Failed;
        this.state.stock = [];
        this.state.stockStatus = WarehouseAdminStatus.Failed;
        this.state.stockBuilding = null;
        this.state.restocks = [];
        this.state.restocksStatus = WarehouseAdminStatus.Failed;
        this.state.retours = [];
        this.state.retoursStatus = WarehouseAdminStatus.Failed;
        this.state.restockHistory = [];
        this.state.restockHistoryStatus = WarehouseAdminStatus.Failed;
        this.state.suppliers = [];
        this.state.suppliersStatus = WarehouseAdminStatus.Failed;
        this.state.supplierInvoices = [];
        this.state.supplierInvoicesStatus = WarehouseAdminStatus.Empty;
        this.state.supplierInvoicesSupplierId = null;
        this.state.orderBuildingReport = null;
        this.state.orderBuildingReportStatus = WarehouseAdminStatus.Empty;
        this.state.deliveredTotalsByBuildingReport = null;
        this.state.deliveredTotalsByBuildingReportStatus = WarehouseAdminStatus.Empty;
        this.state.simpleProductReport = null;
        this.state.simpleProductReportStatus = WarehouseAdminStatus.Empty;
        this.state.deliveredTotalsByPeriodReport = null;
        this.state.deliveredTotalsByPeriodReportStatus = WarehouseAdminStatus.Empty;
        this.state.resupplyTasks = [];
        this.state.resupplyTasksStatus = WarehouseAdminStatus.Empty;
        this.state.isSaving = false;
    }
}